import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from 'wire-frame';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private apiUrl: string;

  constructor(private http: HttpClient, private common: CommonService, private apiService: ApiService) { 
    this.apiUrl = this.apiService.getBaseUrl();
  }

  private getAuthHeaders() {
    const token = localStorage.getItem('jwtToken');
    return {
      headers: new HttpHeaders({
        'Authorization' : `Bearer ${token}`
      })
    }
  }

  getDoctors() {
    return this.http.get(
      // this.common.getBaseUrl() + 'Appointment.php?action=AppointmentsList' + (payload ? '&list=all' : '')
      this.apiUrl + '/doctors', this.getAuthHeaders()
    );
  }
}
